import { r as registerInstance, h, F as Fragment } from './index-5faac9d7.js';
import { a6 as CATEGORY } from './currency-7be6806c.js';
import './product-card-c5e7a62c.js';
import { s as store } from './pes-router-store-0c1092be.js';
import './store-22db8dad.js';
import './index-e29b327a.js';
import { a as getFilteredBreadcrumbs } from './utils-5c7c3926.js';
import { a as addHostToHmcUrls } from './utils-f0ef036b.js';
import './checkoutEventEmitter.service-41cc6ce1.js';
import './_basePickBy-e4f30088.js';
import './_arrayLikeKeys-728b0edd.js';
import './isEmpty-51908328.js';
import './_nodeUtil-f95b2b52.js';
import './_commonjsHelpers-11ca3be1.js';
import './isSymbol-bae590b5.js';
import './_Stack-68736bd1.js';
import './toString-10b0f228.js';
import './_isIndex-3036d479.js';
import './keysIn-6ff99c07.js';
import './hasIn-53d8ae96.js';
import './_flatRest-cb1a737b.js';
import './_baseFlatten-65704796.js';
import './index-5d9a618b.js';
import './pes-product-link-74e48119.js';
import './utils-5735b62e.js';
import './analytics-205f1857.js';
import './helpers-c4d5ad02.js';
import './tslib.es6-613ce1cd.js';
import './__node-resolve_empty-7dfe5913.js';
import './helpers-e12aa36b.js';
import './toNumber-6e3a0b09.js';
import './index-e233ecdd.js';
import './cta-list-298471fe.js';
import './_baseFor-a28737de.js';
import './_copyObject-8b49fce6.js';
import './constants-7d3b1dc0.js';
import './number-57a50dcb.js';
import './analytics-b6a65ffa.js';
import './utils-6c8f178b.js';
import './index-54dd34b7.js';
import './lodash-bd96d09c.js';

const PesAppCategory = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.host = undefined;
    this.showBreadcrumbs = undefined;
    this.categoryAllData = null;
    this.categoryId = undefined;
    this.recentlyViewedProducts = undefined;
    this.countryCode = undefined;
    this.languageCode = undefined;
    this.storageName = '';
    this.currentPageStorageKey = '';
  }
  componentWillRender() {
    store.set('enableAppRouting', true);
  }
  componentWillLoad() {
    this.storageName = `${this.host}${this.countryCode}/${this.languageCode}/`;
    this.currentPageStorageKey = `${CATEGORY}/${this.categoryId}`;
  }
  get customBreadcrumbs() {
    if (!this.showBreadcrumbs) {
      return null;
    }
    return getFilteredBreadcrumbs(this.categoryAllData.breadcrumbs.breadcrumbs);
  }
  get hmcBanner() {
    var _a, _b;
    if (!((_b = (_a = this.categoryAllData) === null || _a === void 0 ? void 0 : _a.mainInfo) === null || _b === void 0 ? void 0 : _b.hmcBanner)) {
      return null;
    }
    const { hmcBanner } = this.categoryAllData.mainInfo;
    addHostToHmcUrls(this.host, hmcBanner);
    return hmcBanner;
  }
  render() {
    const { breadcrumbs: { hideOnMobile }, descriptionInfo: { name, description, readLessLabel, readMoreLabel, badge = null }, mainInfo: { commonFiltersFilterBy, commonFiltersProductFiltersLabel, commonFiltersShowRanges, commonFiltersClearAllLabel, commonFiltersOfferTypeLabel, rangePartofLabel, rangeProductsViewDetailsLabel, productRelationsViewProdLabel, viewOnLabel, readMoreLabel: readMoreLabelMainInfo, readLessLabel: readLessLabelMainInfo, newFilters, subCategories, }, } = this.categoryAllData;
    return (h(Fragment, null, this.showBreadcrumbs && (h("pes-breadcrumbs", { breadcrumbs: this.customBreadcrumbs, hideOnMobile: hideOnMobile, hostWithLocale: this.storageName })), h("pes-category-heading", { name: name, description: description, readLessLabel: readLessLabel, readMoreLabel: readMoreLabel, badge: badge }), h("pes-subcategories", { name: name, sourceId: this.categoryId, commonFiltersFilterBy: commonFiltersFilterBy, commonFiltersProductFiltersLabel: commonFiltersProductFiltersLabel, commonFiltersShowRanges: commonFiltersShowRanges, commonFiltersClearAllLabel: commonFiltersClearAllLabel, commonFiltersOfferTypeLabel: commonFiltersOfferTypeLabel, rangePartofLabel: rangePartofLabel, rangeProductsViewDetailsLabel: rangeProductsViewDetailsLabel, productRelationsViewProdLabel: productRelationsViewProdLabel, viewOnLabel: viewOnLabel, readMoreLabel: readMoreLabelMainInfo, readLessLabel: readLessLabelMainInfo, newFilters: newFilters, subCategories: subCategories, hmcBanner: this.hmcBanner, avoidAccents: true, isPBS: true, categoryId: this.categoryId, currentPageStorageKey: this.currentPageStorageKey, storageName: this.storageName }), h("pes-products-carousel", Object.assign({}, this.recentlyViewedProducts, { isBackgroundGrey: true, class: "pes-app-category__section", hostWithLocale: this.storageName, pageId: this.categoryId, pageType: CATEGORY }))));
  }
};

export { PesAppCategory as pes_app_category };
